import AppConfig, { IS_PROD_ENV } from '@/AppConfig';

export const isAnalyticsTurnedOn =
  IS_PROD_ENV || AppConfig.FORCE_ANALYTICS_TURN_ON;

export const FEATURE_FLAGS = {
  CASHLESS_BOT: 'CASHLESS_BOT',
  CASHLESS_CLAIMS_ARTICLES: 'CASHLESS_CLAIMS_ARTICLES',
  NEW_CASHLESS_CREATE: 'NEW_CASHLESS_CREATE',
  NETWORK_HOSPITALS_V3: 'NETWORK_HOSPITALS_V3',
  HEALTH_WALLET_CLAIMS_V2: 'HEALTH_WALLET_CLAIMS_V2',
  TELEHEALTH_WEB: 'TELEHEALTH_WEB',
};

export enum EDevFlag {
  SHOW_LOGS = 'SHOW_LOGS',
}

export enum ETelehealthTriageEvents {
  Telehealth_Triage_QuestionsExplored = 'Telehealth_Triage_QuestionsExplored',
  Telehealth_Triage_LandingPageViewed = 'Telehealth_Triage_LandingPageViewed',
  Telehealth_Triage_CompletionScreenViewed = 'Telehealth_Triage_CompletionScreenViewed',
  Telehealth_Triage_DoctorSelected = 'Telehealth_Triage_DoctorSelected',
  Telehealth_Triage_FeedbackProvided = 'Telehealth_Triage_FeedbackProvided',
  telehealth_findDoctor_feedbackProvided = 'telehealth::findDoctor_feedbackProvided',
  telehealth_findDoctor_entryInitiated = 'telehealth_findDoctor_entryInitiated',
  telehealth_findDoctor_sessionEarlyExit = 'telehealth_findDoctor_sessionEarlyExit',
  telehealth_findDoctor_assessmentComplete = 'telehealth:findDoctor_assessmentComplete',
  telehealth_findDoctor_recommendationAccepted = 'telehealth::findDoctor_recommendationAccepted',
}

export enum ESufaceEntryPoints {
  TELEHEALTH_HOME = 'TELHEALTH HOME',
  TELEHEALTH_SPECIALITY = 'telehealth_speciality',
  TELEHEALTH_MENTAL_HEALTH = 'telehealth_mental_health',
}

export enum EQuestionarreProgress {
  ASSESSMENT_IN_PROGRESS = 'ASSESSMENT_IN_PROGRESS',
  ASSESSMENT_COMPLETED = 'ASSESSMENT_COMPLETED',
  EMERGENCY_DECLARED = 'EMERGENCY_DECLARED',
  DOCTOR_RECOMMENDED = 'DOCTOR_RECOMMENDED',
}

export enum EThemeNames {
  TELEHEALTH_TRIAGE_BOT = 'telehealthTriageBot',
  MATCH_THERAPIST_DEFAULT = 'matchTherapistDefault',
}

export enum EUserRole {
  DOCTOR = 'doctor',
  USER = 'user',
}

export enum EAnalyticsEvents {
  TELEHEALTH_CHAT_LANDING_PAGE_VIEWED = 'telehealth_chat_landing_page_viewed',
  TELEHEALTH_CHAT_INITIATED = 'telehealth_chat_initiated',
  TELEHEALTH_CHAT_MESSAGE_SENT = 'telehealth_chat_message_sent',
  TELEHEALTH_CHAT_BOOKING_FAILED = 'telehealth_chat_booking_failed',
  TELEHEALTH_CHAT_BOOKING_RETRIED = 'telehealth_chat_booking_retried',
}

export const BOT_ENTITIES = {
  TELE_CONSULT_BOT: 'TELE_CONSULT_BOT',
} as const;

export const DEEPLINK_URLS = {
  BOOK_AMBULANCE: 'https://deeplink.plumhq.com/home?screen=bookambulance',
  FIND_CASHLESS_HOSPITAL: 'https://deeplink.plumhq.com/home?screen=findcashless',
  IN_APP_HELP_CENTER: 'https://deeplink.plumhq.com/home?screen=inapphelpcenter',
} as const;

export {
  ESocketEvent,
  EMessageResponseType,
  EMessageErrorCode,
} from './socketEvents';
